// QQ表情插件
(function($){  
	$.fn.qqFace = function(options){
		var defaults = {
			id : 'facebox',
			path : 'face/',
			assign : 'content',
			tip : 'em_'
		};
		var option = $.extend(defaults, options);
		var assign = $('#'+option.assign);
		var id = option.id;
		var path = option.path;
		var tip = option.tip;
		
		if(assign.length<=0){
			alert('缺少表情赋值对象。');
			return false;
		}

		// 按钮表情展示
		var strFace, labFace;
		if($('#'+id).length<=0){
			strFace = '<div id="'+id+'" style="background:#d0d0d0;overflow:hidden;" class="qqFace">' +
						  '<table border="0" cellspacing="0" cellpadding="0" style="margin:8px auto"><tr>';
			for(var i=1; i<=28; i++){
				labFace = '['+tip+i+']';
				strFace += '<td><img src="'+path+i+'.gif" onclick="$(\'#'+option.assign+'\').setCaret();$(\'#'+option.assign+'\').insertAtCaret(\'' + labFace + '\');" /></td>';
				if( i % 8 == 0 ) strFace += '</tr><tr>';
			}
			strFace += '</tr></table></div>';
		}
		$(this).parent().append(strFace);
		$('#'+id).css("height","0");

		// 标签编码转换
		function replace_em(str){
            str = str.replace(/\</g,'&lt;');
            str = str.replace(/\>/g,'&gt;');
            str = str.replace(/\n/g,'<br/>');
            str = str.replace(/\[em_([0-9]*)\]/g,'<img src="../dist/arclist/$1.gif" border="0" />');
            return str;
        }
		
		$(this).click(function(e){
			if($(this).hasClass("showsmile")){
				$(this).removeClass("showsmile");
				$('#'+id).animate({"height":"0"},500,function(){
					$('#'+id).css({"border-top":"none"});
					$(".icon-smile").removeClass("icon");
				});
			}else{
				$(this).addClass("showsmile");
				$('#'+id).css({"height":"0","border-top":"1px solid #ccc"});
				$(".icon-smile").addClass("icon");
				$('#'+id).animate({"height":"136px"},500);
			}
			e.stopPropagation();
		});
	};

})(jQuery);

jQuery.extend({ 
	unselectContents: function(){ 
		if(window.getSelection) 
		window.getSelection().removeAllRanges(); 
		else if(document.selection) 
		document.selection.empty(); 
	} 
});

jQuery.browser={};(function(){jQuery.browser.msie=false; jQuery.browser.version=0;if(navigator.userAgent.match(/MSIE ([0-9]+)./)){ jQuery.browser.msie=true;jQuery.browser.version=RegExp.$1;}})();
jQuery.fn.extend({ 
	selectContents: function(){ 
		$(this).each(function(i){ 
			var node = this; 
			var selection, range, doc, win; 
			if ((doc = node.ownerDocument) && (win = doc.defaultView) && typeof win.getSelection != 'undefined' && typeof doc.createRange != 'undefined' && (selection = window.getSelection()) && typeof selection.removeAllRanges != 'undefined'){ 
				range = doc.createRange(); 
				range.selectNode(node); 
				if(i == 0){ 
					selection.removeAllRanges(); 
				} 
				selection.addRange(range); 
			} else if (document.body && typeof document.body.createTextRange != 'undefined' && (range = document.body.createTextRange())){ 
				range.moveToElementText(node); 
				range.select(); 
			} 
		}); 
	},
	setCaret: function(){
        // $.browser.mozilla = /firefox/.test(navigator.userAgent.toLowerCase());
        // $.browser.webkit = /webkit/.test(navigator.userAgent.toLowerCase());
        // $.browser.opera = /opera/.test(navigator.userAgent.toLowerCase());
        // $.browser.msie = /msie/.test(navigator.userAgent.toLowerCase());
		if(!$.browser.msie) return;
		var initSetCaret = function(){ 
			var textObj = $(this).get(0); 
			textObj.caretPos = document.selection.createRange().duplicate(); 
		}; 
		$(this).click(initSetCaret).select(initSetCaret).keyup(initSetCaret); 
	}, 

	insertAtCaret: function(textFeildValue){ 
		var textObj = $(this).get(0); 
		if(document.all && textObj.createTextRange && textObj.caretPos){ 
			var caretPos=textObj.caretPos; 
			caretPos.text = caretPos.text.charAt(caretPos.text.length-1) == '' ? 
			textFeildValue+'' : textFeildValue; 
		} else if(textObj.setSelectionRange){ 
			var rangeStart=textObj.selectionStart; 
			var rangeEnd=textObj.selectionEnd; 
			var tempStr1=textObj.value.substring(0,rangeStart); 
			var tempStr2=textObj.value.substring(rangeEnd); 
			textObj.value=tempStr1+textFeildValue+tempStr2; 
			textObj.focus(); 
			var len=textFeildValue.length; 
			textObj.setSelectionRange(rangeStart+len,rangeStart+len); 
			textObj.blur(); 
		}else{ 
			textObj.value+=textFeildValue; 
		} 
	} 
});


//////////////////
// WEBPACK FOOTER
// ./static/lib/jquery.qqFace.js
// module id = SyNO
// module chunks = 0